import { render, staticRenderFns } from "./neck.vue?vue&type=template&id=91c35920&scoped=true&"
import script from "./neck.vue?vue&type=script&lang=js&"
export * from "./neck.vue?vue&type=script&lang=js&"
import style0 from "./neck.vue?vue&type=style&index=0&id=91c35920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c35920",
  null
  
)

export default component.exports